<template>
  <div class="page_servants">
    <h1>Služebníci</h1>
    <tabloid name="servants" :columns="columns" :data="servants">
      <template v-slot:playingOutpostId="{ value }">{{ value }}. PH</template>
      <template v-slot:servantType="{ value }">{{ value | cz }}</template>
      <template v-slot:actions="{ row }">
        <button
          v-if="!row.isServantConfirmed"
          @click="accept(row.id)"
          class="accept"
          title="Přijmout">
          <i class="fa fa-check"></i>
        </button>
        <button @click="reject(row.id)" class="reject" title="Odmítnout">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { _ } from '../../extend';
import tabloid from '../../components/tabloid.vue';

export default {
  name: "servants",
  components: {
    tabloid,
  },
  data: () => ({
    columns: {
      playingOutpostId: { title: "Hlídka" },
      servantType: { title: "Role" },
      name: { title: "Jméno" },
      surname: { title: "Příjmení" },
      email: { title: "E-mail" },
      phone: { title: "Telefon" },
      actions: { title: " " },
    },
  }),
  computed: {
    servants() {
      const servants = _.filter(this.$store.state.participants, p => p.isServant);
      return servants;
    }
  },
  methods: {
    accept(participantId) {
      this.$store.commit("update", {
        paths: ["participants", participantId, "isServantConfirmed"],
        value: true
      });
    },
    reject(participantId) {
      this.$store.commit("update", {
        paths: ["participants", participantId, "isServant"],
        value: false
      });
    },
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_servants
  @include table-view()
  td
    text-align: center
  .accept
    @include button-primary()
    @include first-input()
  .reject
    @include button-danger()
    @include last-input()
</style>